var map = {
	"./images/amulet_01.png": 1424,
	"./images/amulet_02.png": 1425,
	"./images/amulet_03.png": 1426,
	"./images/amulet_04.png": 1427,
	"./images/amulet_05.png": 1428,
	"./images/amulet_06.png": 1429,
	"./images/amulet_07.png": 1430,
	"./images/amulet_08.png": 1431,
	"./images/amulet_09.png": 1432,
	"./images/amulet_10.png": 1433,
	"./images/amulet_11.png": 1434,
	"./images/amulet_12.png": 1435,
	"./images/atk.png": 1436,
	"./images/background.jpg": 1437,
	"./images/before-choose.png": 1438,
	"./images/bg-choose-power.jpg": 1439,
	"./images/boss-item-block.png": 1440,
	"./images/choose-atk.png": 1441,
	"./images/choose-back.png": 1442,
	"./images/choose-button.png": 1443,
	"./images/choose-def.png": 1444,
	"./images/choose-hp.png": 1445,
	"./images/choose-item-border.png": 1446,
	"./images/choose-power.png": 1447,
	"./images/collection-new.png": 1448,
	"./images/def.png": 1449,
	"./images/hidden-power-goten.png": 1450,
	"./images/hidden-power.png": 1451,
	"./images/home.png": 1452,
	"./images/hp.png": 1453,
	"./images/item-tags.png": 1454,
	"./images/line.png": 1455,
	"./images/power-all1.png": 1456,
	"./images/power-all2.png": 1457,
	"./images/power-all3.png": 1458,
	"./images/power-all5.png": 1459,
	"./images/power-atk.png": 1460,
	"./images/power-atk1.png": 1461,
	"./images/power-atk2.png": 1462,
	"./images/power-atk3.png": 1463,
	"./images/power-atk5.png": 1464,
	"./images/power-def.png": 1465,
	"./images/power-def1.png": 1466,
	"./images/power-def2.png": 1467,
	"./images/power-def3.png": 1468,
	"./images/power-def5.png": 1469,
	"./images/power-hp.png": 1470,
	"./images/power-hp1.png": 1471,
	"./images/power-hp2.png": 1472,
	"./images/power-hp3.png": 1473,
	"./images/power-hp5.png": 1474,
	"./images/power-none.png": 1475,
	"./images/remember_01.png": 1476,
	"./images/remember_02.png": 1477,
	"./images/remember_03.png": 1478,
	"./images/remember_04.png": 1479,
	"./images/remember_05.png": 1480,
	"./images/remember_06.png": 1481,
	"./images/remember_07.png": 1482,
	"./images/remember_08.png": 1483,
	"./images/remember_09.png": 1484,
	"./images/remember_10.png": 1485,
	"./images/remember_11.png": 1486,
	"./images/remember_12.png": 1487,
	"./images/sound.png": 1488,
	"./images/tutorial.png": 1489,
	"./images/yardnapha.png": 1490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1423;